import { render, staticRenderFns } from "./Header1Section.vue?vue&type=template&id=0350e130&scoped=true&"
import script from "./Header1Section.vue?vue&type=script&lang=ts&"
export * from "./Header1Section.vue?vue&type=script&lang=ts&"
import style0 from "./Header1Section.vue?vue&type=style&index=0&id=0350e130&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0350e130",
  null
  
)

export default component.exports